import { render, staticRenderFns } from "./AreaModal.vue?vue&type=template&id=583b1db3&"
import script from "./AreaModal.vue?vue&type=script&lang=js&"
export * from "./AreaModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports